<template>
  <div>
    <CCol xl="12" lg="12" md="12" style="margin-top: 20%" v-if="Spinner">
      <div
        class="sk-wave primary"
        color="success"
        style="margin: auto; width: 10%; top: 50% !important"
      >
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
        <div class="sk-wave-rect"></div>
      </div>
    </CCol>
    <CRow v-else>
      <CCol>
        <CCard style="margin-top: 20px">
          <CCardBody>
            <JsonCSV
              color="primary"
              class="btn btn-default mb-2 clr"
              :data="tableData"
              name="User-list.csv"
            >
              Download CSV (This is a slot)
            </JsonCSV>
            <CButton
              block
              color="success"
              style="float: right; width: 100px"
              @click="myModal = true"
            >
              <i class="fa fa-plus" aria-hidden="true"></i> Add new</CButton
            >
            <CDataTable
              :items="tableData"
              :fields="fields"
              column-filter
              table-filter
              items-per-page-select
              :items-per-page="10"
              hover
              sorter
              pagination
            >
              <template #Action="{ item, index }">
                <td>
                  <CButton
                    color="primary"
                    variant="outline"
                    square
                    size="sm"
                    style="width: 54px"
                    @click="editToken(item, index)"
                  >
                    Edit </CButton
                  ><br /><br />
                  <CButton
                    color="danger"
                    variant="outline"
                    square
                    size="sm"
                    @click="deleteRoute(item, index)"
                  >
                    Delete
                  </CButton>
                </td>
              </template>
            </CDataTable>
            <CModal title="Add promocode" :show.sync="myModal">
              <CInput
                placeholder="Enter promocode"
                v-model="promocode"
                type="text"
              />
              <CTextarea
                label="Description"
                placeholder="Content..."
                horizontal
                rows="4"
                v-model="description"
              />
              <CInput placeholder="field3" v-model="field3" type="text" />
              <CInput placeholder="field4" v-model="field4" type="text" />
              <!-- <span  style="color: red">please enter coin</span> -->
              <template #footer>
                <!-- <CButton @click="darkModal = false" color="danger">cancel</CButton> -->
                <CButton color="success" @click="savepromo()">Save</CButton>
              </template>
            </CModal>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<style src="spinkit/spinkit.min.css"></style>
<script>
import { APIService } from "../../apiservice.js";
import Swal from "sweetalert2";
import AppVue from "../../App.vue";
import firebase from "firebase";
import Apexchart from "vue-apexcharts";
const db = firebase.firestore();
import moment from "moment";
import { getStyle, hexToRgba } from "@coreui/utils/src";
import Userchart from "./userchart.vue";
import JsonCSV from "vue-json-csv";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  components: {
    Apexchart,
    Userchart,
    JsonCSV,
    DatePicker,
  },
  name: "AdvancedTables",
  data() {
    return {
      Spinner: true,
      promocode: "",
      description: "",
      field3: "",
      field4: "",
      hidechart: false,
      myModal: false,
      tableData: [],
      fields: [
        {
          label: "Date",
          key: "date",
          sortable: true,
        },
        {
          label: "Promcode",
          key: "promocode",
          sortable: true,
        },
        {
          label: "Description",
          key: "description",
          sortable: true,
        },

        // {
        //    label: "field3",
        //   key: "field3",
        //   sortable: true,
        // },
        // {
        //    label: "field4",
        //   key: "field4",
        //   sortable: true,
        // },
        //   {
        //   key: "Action",
        //   sortable: true,
        // },
      ],
      value1: [],
      details: [],
      collapseDuration: 0,
    };
  },

  methods: {
    savepromo() {
      var date = new Date();
      db.collection("promocode")
        .add({
          promocode: this.promocode,
          description: this.description,
          Date: date,
          field3: this.field3,
          field4: this.field4,
        })
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 3000,
          });
          this.myModal = false;
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    },

    gettokens() {
      this.tableData = [];
      const db = firebase.firestore();
      db.collection("promocode")
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            let backenddate =
              doc.data().Date != null
                ? moment(doc.data().Date.seconds * 1000).format("DD-MMM-YYYY")
                : "";
            this.Spinner = false;
              this.tableData.push({
                id: doc.id,
                promocode: doc.data().promocode,
                description: doc.data().description,
                date: backenddate,
              });
          });
        });
    },

    rowClicked(item, index, column, e) {
      // console.log("edit item", item.id);
      this.documentId = item.id;
    },

    deleteRoute(item) {
      console.log("deleteRoute", item.id);
      this.documentId = item.id;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          width: "600px",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.deletecompanyDetails();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    deletecompanyDetails(item) {
      db.collection("promocode")
        .doc(this.documentId)
        .delete()
        .then(() => {
          // console.log("Document successfully deleted!");
          this.gettokens();
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },
  },
  created() {
    this.gettokens();
  },
};
</script>
<style >
.clr {
  color: #fff !important;
  background-color: #321fdb !important;
}
.swal2-cancel {
  margin: 10px !important;
}
.sk-wave-rect {
    background-color: #4638c2;
    height: 100%;
    width: 15%;
    -webkit-animation: sk-wave 1.2s ease-in-out infinite;
    animation: sk-wave 1.2s ease-in-out infinite;
}
</style>